<template>
    <div class="boxbranco vigilancia mb-2">
        <b-breadcrumb>
            <b-breadcrumb-item v-for="(item, index) in bread" :key="index" @click="breadControl(item, index)">{{item.text}}</b-breadcrumb-item>
        </b-breadcrumb>

        <b-button v-if="diretorio !== '/Vigilancia'" variant="light" class="mb-2" size="sm" @click="voltaDiretorio()">
            <i class="fa fa-arrow-left" aria-hidden="true"></i> Voltar
        </b-button>

        <i class="mt-3 fa fa-circle-o-notch fa-spin fa-3x fa-fw loading-icon d-block" v-if="!listaPastas"></i>

        <div class="bordas diretorio" v-if="listaPastas && listaPastas.length > 0">
            <pasta :titulo="item" v-for="(item, index) in listaPastas" :key="index" @adicionaDiretorio="adicionaDiretorio" />
        </div>

        <div v-if="diretorio !== '/Vigilancia'">
            <i class="mt-3 fa fa-circle-o-notch fa-spin fa-3x fa-fw loading-icon d-block" v-if="!listaArquivos"></i>

            <b-alert class="mt-2" show variant="warning" v-if="listaArquivos && listaArquivos.length == 0">
                Nenhum arquivo para download nesta pasta
            </b-alert>

            <b-button
                v-if="listaArquivos && usuario.psvs == 2"
                class="d-block mt-2"
                variant="light"
                size="sm"
                @click="modalUpload()"
            >
                <i class="fa fa-upload" aria-hidden="true"></i> Inserir documento
            </b-button>

            <b-table
                v-if="listaArquivos && listaArquivos.length > 0"
                class="mt-2"
                responsive
                hover
                :items="listaArquivos"
                :fields="colunas"
            >
                <template v-slot:cell(arquivo)="row">
                    <i :class="verifyIcon(row.item)" aria-hidden="true" class="mr-2"></i> {{row.item}}
                </template>

                <template v-slot:cell(download)="row">
                    <b-button variant="primary" size="sm" @click="downloadFile(row.item)">{{row.item.includes('.pdf') ? 'Abrir' : 'Download'}}</b-button>
                    <b-button class="ml-2" v-if="usuario.psvs == 2" variant="danger" size="sm" @click="modalDelete(row.item)"><i class="fa fa-trash-o" aria-hidden="true"></i></b-button>
                </template>
            </b-table>
        </div>

         <vue-modality
                ref="modalDelete"
                title="Excluir Documento"
                centered
                ok-title="Apagar"
                :ok-loading="sendingFile"
                cancel-title="Cancelar"
                @ok="deleteFile"
                @cancel="$refs.modalDelete.hide()"
            >
                Tem certeza de que deseja excluir o documento: <strong>{{arquivoSelecionado}}</strong> ?
        </vue-modality>

         <vue-modality 
                ref="modalUpload"
                title="Inserir Documento"
                centered
                ok-title="Enviar"
                :ok-disabled="!fileToUpload"
                :ok-loading="sendingFile"
                cancel-title="Cancelar"
                @ok="uploadFile"
                @cancel="$refs.modalUpload.hide()"
            >
                <b-form-file
                    v-model="fileToUpload"
                    placeholder="Escolha o arquivo"
                    drop-placeholder="Solte-o aqui..."
                ></b-form-file>
        </vue-modality> 

    </div>
</template>

<script>
import Pasta from './shared/pasta/Pasta.vue'
export default {
    components: {
        Pasta,
    },
    mounted () {
        this.$store.dispatch('arquivos/listarPastas', this.diretorio)
    },
    data() {
        return {
            diretorio: '/Vigilancia',
            fileToUpload: null,
            sendingFile: false,
            arquivoSelecionado: '',
            colunas: [
                { key: 'arquivo', label: 'Arquivo' },
                { key: 'download', label: '', class: 'text-right'},
            ],
            files: [
                {type: '.pdf', icon: 'fa fa-file-pdf-o'},
                {type: '.png', icon: 'fa fa-file-image-o'},
                {type: '.jpeg', icon: 'fa fa-file-image-o'},
                {type: '.jpg', icon: 'fa fa-file-image-o'},
                {type: '.bmp', icon: 'fa fa-file-image-o'},
                {type: '.txt', icon: 'fa fa-file-text-o'},
                {type: '.xls', icon: 'fa fa-file-excel-o'},
                {type: '.xlsx', icon: 'fa fa-file-excel-o'},
                {type: '.doc', icon: 'fa fa-file-word-o'},
                {type: '.docx', icon: 'fa fa-file-word-o'},
                {type: '.ppt', icon: 'fa fa-file-powerpoint-o'},
                {type: '.pptx', icon: 'fa fa-file-powerpoint-o'},
                {type: '.zip', icon: 'fa fa-file-archive-o'},
                {type: '.rar', icon: 'fa fa-file-archive-o'},
            ] 
        }
    },
    computed: {
        usuario () {
            return this.$store.getters['sessao/getUsuario']
        },
        listaPastas () {
            return this.$store.getters['arquivos/getListaPastas']
        },
        listaArquivos () {
            return this.$store.getters['arquivos/getListaArquivos']
        },
        bread () {
            let items = []

            let dir = this.diretorio.split('/')
            dir.shift()

            dir.forEach(i => {
                items.push({ text: i })
            })

            return items
        }
    },
    watch: {
        diretorio(value) {
            this.$store.dispatch('sessao/verificaSessao')
            let dir = this.diretorio.replace(/ /g, '_')
            this.$store.dispatch('arquivos/listarPastas', dir)
            if (this.diretorio != '/Vigilancia') this.$store.dispatch('arquivos/listarArquivos', dir)
        }
    },
    methods: {
         verifyIcon(name) {
            let type = ''
            this.files.forEach(i => {
                if (name.includes(i.type)) {
                    type = i;
                    return
                }
            })

            if (type != '') return type.icon
            else return ''
        },
        async downloadFile(arquivo) {
            let file = arquivo.replace(/ /g, '%20')
            let dir = this.diretorio.replace(/ /g, '_')
            let url = 'https://campograndems.labinovaapsfiocruz.com.br/publico/downloads' + dir + '/' + file

            if (file.includes('.pdf')) {
                let link = document.createElement('a')
                link.href = url
                link.target = "_blank"
                document.body.appendChild(link);
                link.click();
                return
            }

            let response = await this.$store.dispatch('arquivos/downloadFile', url)
            this.forceDownload(response, arquivo)
        },
        forceDownload(response, name) {
            var fileURL = window.URL.createObjectURL(new Blob([response.data]));
            var fileLink = document.createElement('a');

            fileLink.href = fileURL;
            fileLink.setAttribute('download', name);
            document.body.appendChild(fileLink);

            fileLink.click();
        },
        modalDelete (item) {
            this.arquivoSelecionado = item
            this.$refs.modalDelete.open()
        },
        deleteFile () {
            this.sendingFile = true;
            let arquivo = this.arquivoSelecionado
            let dir = this.diretorio.replace(/ /g, '_')
            let path =  dir + '/' + arquivo

            let data = new FormData()
            data.set('opcao', 'remover')
            data.set('link', path)

            this.$store.dispatch('arquivos/deleteFile', data).then(() => {
                this.sendingFile = false;
                this.$refs.modalDelete.hide()
                this.$store.dispatch('arquivos/listarArquivos', dir)
            })
        },
        modalUpload () {
            this.fileToUpload = null
            this.$refs.modalUpload.open()
        },
        uploadFile () {
            this.sendingFile = true;
            let diretorio = this.diretorio.replace(/ /g, '_') + '/'
            
            let data = new FormData();
            data.append('arquivo', this.fileToUpload, this.fileToUpload.name)
            data.set('opcao', 'upload')
            data.set('diretorio', diretorio)

            this.$store.dispatch('arquivos/upload', data).then(() => {
                this.sendingFile = false;
                this.$refs.modalUpload.hide()
                this.$store.dispatch('arquivos/listarArquivos', this.diretorio.replace(/ /g, '_'))
            })
        },
        adicionaDiretorio(value) {
            this.diretorio = this.diretorio + '/' + value
        },
        voltaDiretorio() {
            let dir = this.diretorio.split('/')
            dir.length = dir.length - 1
            dir = dir.join('/')

            this.diretorio = dir
        },
        breadControl(item, index) {
            let i = index + 2
            let dir = this.diretorio.split('/')
            dir.length = dir.length - (dir.length - i)
            dir = dir.join('/')

            this.diretorio = dir
        }
    },
}
</script>

<style>
.table td, .table th {
    min-width: 130px!important;
}
</style>